// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3QQAX","label":"Radio_label__12Ntz","checkMark":"Radio_checkMark__2_vsz","disabled":"Radio_disabled__3uL3y"};